module.exports = __webpack_public_path__ + "static/media/mini-headset-mic.acf672e0.jpg";